import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit";

import messageBarReducer from "../features/messageBar/messageBarSlice";
import questionnaireReducer from "../features/questionnaire/questionnaireSlice";
import userReducer from "../features/user/userSlice";

export const store = configureStore({
  reducer: {
    messageBar: messageBarReducer,
    questionnaire: questionnaireReducer,
    user: userReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
